export class OperationType {
  public static readonly SIGN = 1;
  public static readonly REVIEW = 2;
  public static readonly VISUALIZATION = 3;
  public static readonly NOTIFY = 4;
}
